"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareSession = shareSession;
const client_1 = require("../../session/client/index.js");
async function shareSession(calculatorId) {
    const headers = {};
    const sessionId = (0, client_1.getRuntimeSessionId)();
    if (sessionId) {
        headers.Authorization = `Bearer ${sessionId}`;
    }
    const response = await fetch(`/api/calculators/${calculatorId}/sessions:share`, {
        method: "POST",
        headers,
        credentials: "include",
    });
    if (!response.ok) {
        throw response;
    }
    const data = await response.json();
    return data;
}
